import React, { useState } from 'react';
import { updateProductReviewApi } from '../../utils/productReviewApi';
import { getProductReviewId } from './productReviewUtils';
import '../css/Category.css';

const ProductReviewEdit = ({ editItem, onClose, onSuccess }) => {
  const [form, setForm] = useState({
    ProductId: editItem.ProductId ?? editItem.productId ?? '',
    UserId: editItem.UserId ?? editItem.userId ?? '',
    Rating: String(editItem.Rating ?? editItem.rating ?? 5),
    ReviewTitle: editItem.ReviewTitle ?? editItem.reviewTitle ?? '',
    ReviewText: editItem.ReviewText ?? editItem.reviewText ?? '',
  });
  const [saving, setSaving] = useState(false);
  const [formError, setFormError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    const rating = Number(form.Rating);
    if (!Number.isFinite(rating) || rating < 1 || rating > 5) {
      setFormError('Rating must be between 1 and 5.');
      return;
    }
    setSaving(true);
    setFormError(null);
    try {
      await updateProductReviewApi({
        ProductReviewId: Number(getProductReviewId(editItem)),
        ProductId: Number(form.ProductId),
        UserId: Number(form.UserId),
        Rating: rating,
        ReviewTitle: form.ReviewTitle.trim(),
        ReviewText: form.ReviewText.trim() || null,
      });
      onSuccess('Review updated successfully.');
    } catch (e) {
      setFormError(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="cat-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="cat-modal" style={{ maxWidth: 640 }}>
        <div className="cat-modal-header">
          <h5>Edit Review #{getProductReviewId(editItem)}</h5>
          <button type="button" className="cat-modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="cat-modal-body">
          {formError && <div className="alert alert-danger py-2 mb-3">{formError}</div>}
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label">Product ID</label>
              <input className="form-control" name="ProductId" value={form.ProductId} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">User ID</label>
              <input className="form-control" name="UserId" value={form.UserId} onChange={handleChange} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Rating (1–5)</label>
              <select className="form-select" name="Rating" value={form.Rating} onChange={handleChange}>
                {[5, 4, 3, 2, 1].map((n) => (
                  <option key={n} value={n}>{n} star{n > 1 ? 's' : ''}</option>
                ))}
              </select>
            </div>
            <div className="col-12">
              <label className="form-label">Review Title</label>
              <input className="form-control" name="ReviewTitle" value={form.ReviewTitle} onChange={handleChange} />
            </div>
            <div className="col-12">
              <label className="form-label">Review Text</label>
              <textarea className="form-control" name="ReviewText" rows={4} value={form.ReviewText} onChange={handleChange} />
            </div>
          </div>
        </div>
        <div className="cat-modal-footer">
          <button type="button" className="btn btn-light me-2" onClick={onClose}>Cancel</button>
          <button type="button" className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Update'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductReviewEdit;
